<template>
  <td :aria-colindex="index" role="cell" class="cell__container">
    <div v-if="cell.final || cell.initial" class="cell">
      <div class="d-flex justify-content-between flex-column flex-xl-row">
        <div v-if="cell.final" :class="'cell__final ' + (index === 'remaining_charge' ? '-higlight' : '')">
          {{ cell.final }}
        </div>
        <div v-if="cell.initial && cell.initial !== cell.final" class="cell__initial">({{ cell.initial }})</div>
      </div>
      <div v-if="cell.discount" class="cell__discount">
        <FontAwesomeIcon icon="fa-light fa-circle-exclamation" />{{ cell.discount }}
      </div>
    </div>
    <div v-else>--</div>
  </td>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "RegistrationCompensationTableAmountCellComponent",
  components: { FontAwesomeIcon },
  props: {
    cell: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  emits: [],
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.cell {
  padding: 15px 10px;
  font-size: 15px;

  &__container {
    width: 22%;
  }

  &__final {
    font-weight: 600;
    color: var(--primary-color);
    @include dark-theme {
      color: #bfc9d4;
    }

    &.-higlight {
      font-size: 16px;
    }
  }

  &__discount {
    margin-top: 10ox;
    max-width: 300px;
    font-size: 12px;
    color: var(--primary-color);
    display: flex;
    align-items: center;

    @include dark-theme {
      color: $white;
    }

    svg {
      width: 10px;
      height: 10px;
      margin-right: 5px;
    }
  }
}
</style>
